// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1VixO","title":"Info_title__1O5ec","links":"Info_links__2wkTu","link":"Info_link__3PgcF","logo":"Info_logo__r3epg"};